import classNames from "classnames";
import React, { memo } from "react";
import Color from 'color';

function calcBarPercentages(...values) {
  const total = values.reduce((p, v) => p + v, 0);

  if (total > 0)
    return values.map(v => `${100.0 * v / total}%`);
  else
    return values.map(v => `${100.0 / values.length}%`);
}

function arrayPropEqual(oldValue, newValue) {
  if (oldValue?.length !== newValue?.length) {
    return false;
  }
  for(var i=0; i<oldValue.length; i++)
    if (oldValue[i] !== newValue[i])
        return false;
  return true;
}

const Bar = memo(({ thickness, values, colors }) => {
  const factors = calcBarPercentages(...values);

  return (
    <div className='bar__bar bar__notchedBar' style={thickness && {"--bar-height": thickness}}>
      {
        factors.map((factor, index) => <div key={index} style={{flexBasis: factor, backgroundColor: colors[index] }} />)
      }
    </div>
  )
}, (oldProps, newProps) => {
  return oldProps.thickness === newProps.thickness && arrayPropEqual(oldProps.values, newProps.values) && arrayPropEqual(oldProps.colors, newProps.colors);
});

const Bar1v14Bars = memo(({ name, player1, player1alt, player2, player2alt, leftColor, rightColor }) => {

  player1 = player1 - player1alt;
  player2 = player2 - player2alt;

  const factors = calcBarPercentages(player1, player2, player1alt, player2alt);

  return (
    <div className='bar'>
      <h1 className='bar__header'>{name}</h1>
      <div className={classNames("bar__bar bar__notchedBar", name)}>
        <div className="bar__labels">
          <h1 className="text-white">{parseInt(player1)}</h1>
          <h1 className="text-white text-right">{parseInt(player2)}</h1>
        </div>
        <div style={{flexBasis: factors[2], backgroundColor: Color(leftColor).darken(0.4).desaturate(0.1) }}></div>
        <div style={{flexBasis: factors[0], backgroundColor: leftColor }}></div>
        <div style={{flexBasis: factors[1], backgroundColor: rightColor }}></div>
        <div style={{flexBasis: factors[3], backgroundColor: Color(rightColor).darken(0.4).desaturate(0.1) }}></div>
      </div>
    </div>
  )
} );

export { Bar, Bar1v14Bars };
